import { BaseModel } from "../BaseModel";
import { BaseFindResult } from "../BaseFindResult";
import { EventStatusModel } from "./EventStatusModel";

export class EventStatusFindResultModel extends BaseFindResult {

    public getDataItem(i: number): EventStatusModel {
        let o: EventStatusModel = Object.assign(new EventStatusModel(), this.data[i]);
        return o;
    }

    public get dataTyped(): EventStatusModel[] {

        let d: EventStatusModel[] = [];

        for (var i = 0; i < this.data.length; i++) {
            d.push(this.getDataItem(i));
        }
        return d;
    }

    public override assignObjects(): void {
        super.assignObjects();

        for (var i = 0; i < this.data.length; i++) {
            let o: EventStatusModel = Object.assign(new EventStatusModel(), this.data[i]);
            this.data[i] = o;
        }
    }

}
